module.exports = __webpack_public_path__ + "img/img0304.c657bef4.png";